import { GraphQLClient } from "graphql-request"
import { useEffect, useState } from "react"
import {
  GetUserOrganizationAdminsDocument,
  GetUserOrganizationAdminsQuery,
  GetUserOrganizationAdminsQueryVariables,
} from "../generated/graphql"
import { ENDPOINTS } from "../utils/endpoints"
import { useSession } from "./useSession"

export const useIsOrgAdmin = () => {
  const { session } = useSession()
  const [isOrgAdmin, setIsOrgAdmin] = useState<boolean>(false)

  useEffect(() => {
    if (!session?.userId) {
      return
    }
    ;(async () => {
      const client = new GraphQLClient(ENDPOINTS.GRAPHQL, {
        headers: { Authorization: `Bearer ${session.jwt}` },
      })
      const getUserOrgAdminsResponse = await client.request<
        GetUserOrganizationAdminsQuery,
        GetUserOrganizationAdminsQueryVariables
      >(GetUserOrganizationAdminsDocument, {
        id: session?.userId,
      })
      const orgAdmins =
        getUserOrgAdminsResponse.users_by_pk?.organization_admins
      setIsOrgAdmin(orgAdmins !== undefined && orgAdmins.length > 0)
    })()
  }, [session])

  return isOrgAdmin
}
